import React, { useState, useEffect, useRef } from "react";
import "./MultiSelect.css";

function MultiSelect(props) {
  const [selectOptions, setSelectOptions] = useState(props.selectOptions);
  const [selectActive, setSelectActive] = useState(false);
  const [selectedArr, setSelectedArr] = useState(props.initVal ? props.initVal : "");
  const [selectSearch, setSelectSearch] = useState("");
  const selectRef = useRef("");
  useEffect(() => {
    setSelectOptions(props.selectOptions);
    if (props.inAvailability) {
      setSelectActive(true);
    }
  }, [props]);

  const openCloseSelect = () => {
    setSelectActive(!selectActive);
    if (props.selectSearch) {
      props.selectSearch("");
      setSelectSearch("");
    }
  };

  const updateSelectState = (val) => {
    var selTemp = [...selectedArr];
    if (val.value !== "Show All") {
      if (selTemp.indexOf(selectedArr.filter((item) => item.value === "Show All")[0]) > -1) {
        selTemp.splice(selTemp.indexOf(selectedArr.filter((item) => item.value === "Show All")[0]), 1);
        selTemp.push(val);
      } else if (selTemp.indexOf(selectedArr.filter((item) => item.value === val.value)[0]) > -1) {
        selTemp.splice(selTemp.indexOf(selectedArr.filter((item) => item.value === val.value)[0]), 1);
        if (selTemp.length === 0 && props.inQuestionare !== true) {
          selTemp.push({ value: "Show All" });
        }
      } else {
        selTemp.push(val);
      }
    } else {
      selTemp = [];
      selTemp.push(val);
    }
    setSelectedArr(selTemp);
    //setSelectActive(false);
    if (props.selectCallback && props.callBackValue) {
      props.selectCallback(selTemp, props.callBackValue);
    }
  };

  const handleSelectSearch = (val) => {
    if (props.selectSearch) {
      props.selectSearch(val);
    } else if (props.externalSearch) {
      props.externalSearch(val);
    }
    setSelectSearch(val);
  };

  function useOutsideSelect(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setSelectActive(false);
          if (props.inAvailability && props.openCloseMulti) {
            props.openCloseMulti(-1);
          }
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useOutsideSelect(selectRef);

  return (
    <div
      className={
        props.selectError && (!selectedArr || selectedArr === "Select Exercise" || selectedArr === "Reps")
          ? " prog_err_input"
          : ""
      }
      ref={selectRef}
    >
      {!props.inAvailability && (
        <div
          className={
            "multi_main" +
            (selectActive && (selectOptions.length > 0 || props.selectSearch || props.externalSearch)
              ? " multi_main_active"
              : "") +
            (props.disabled ? " select_main_disabled" : "")
          }
          onClick={() => openCloseSelect(selectActive)}
        >
          {props.externalSearch && !selectedArr && (
            <input
              type="text"
              value={selectSearch}
              placeholder={props.selectSearchPlacehold ? props.selectSearchPlacehold : ""}
              className="select_search select_external_search"
              onChange={(e) => handleSelectSearch(e.target.value)}
            />
          )}
          <div className="select_values_contain">
            <div className={"select_placeholder" + (selectedArr ? " sp_act" : " sp_inact")}>
              {props.noPlaceholdAfterValue && selectedArr ? "" : props.placeholder}
            </div>
            <div className="multi_value">
              {selectedArr.length > 0 ? selectedArr[0].value + (selectedArr[1] ? ", " + selectedArr[1].value : "") : ""}
            </div>
          </div>
          <div className={"select_main_arrow" + (props.disabled ? " select_arrow_disabled" : "")}></div>
        </div>
      )}
      <div
        className={
          "options_hold" +
          (props.inAvailability ? " multi_oh_adjusted" : "") +
          (selectActive && (selectOptions.length > 0 || props.selectSearch || props.externalSearch)
            ? " multi_oh_enabled"
            : " oh_disabled")
        }
      >
        {props.inAvailability && <div className="copy_times_text">Copy times to:</div>}
        {props.selectSearch && (
          <input
            type="text"
            value={selectSearch}
            placeholder={props.selectSearchPlacehold ? props.selectSearchPlacehold : ""}
            className="select_search"
            onChange={(e) => handleSelectSearch(e.target.value)}
          />
        )}
        {selectOptions.length > 0 ? (
          selectOptions.map((option, i) => (
            <div
              key={i}
              className={
                "multi_oh_option" +
                (props.inAvailability ? " multi_oh_avail" : "") +
                (selectedArr.filter((item) => item.value === option.value).length > 0 ? " multi_green" : "")
              }
              onClick={() => updateSelectState(option)}
            >
              <div
                className={
                  "multi_check" +
                  (selectedArr.filter((item) => item.value === option.value).length > 0 ? " multi_checked" : "")
                }
              ></div>
              {option.value}
            </div>
          ))
        ) : (
          <div className="multi_oh_option option_no_res">No results found.</div>
        )}
        {props.inAvailability && (
          <div className="multi_button" onClick={() => props.openCloseMulti(-1, true)}>
            Apply
          </div>
        )}
      </div>
    </div>
  );
}

export default MultiSelect;
